import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import logo from "shared/assets/images/logo.svg";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";
import { API_ORIGIN } from "utils/helpers/apiOrigin";
import { getAuthDescriptor } from "utils/helpers/authProvider";
import View from "./View";

const SetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const { t: auth } = useTranslation(NAME_SPACES.AUTH);
  const UNAVAILABLE = auth("SET_PASSWORD.UNAVAILABLE", { returnObjects: true });

  const userId = searchParams.get("userId");
  const code = searchParams.get("code");
  // A missing userId/code means the link is malformed; a failed submit means the
  // one-time code was already consumed (or expired) — both render as unavailable.
  const [unavailable, setUnavailable] = useState(!userId || !code);

  const onSubmit = async ({ password }) => {
    const path =
      get(getAuthDescriptor(), "paths.setPassword") ||
      "/api/auth/zitadel/set-password";
    setLoading(true);
    try {
      const response = await fetch(`${API_ORIGIN}${path}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, code, password }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      navigate(SCREENS.AUTH.SIGN_IN.path, { replace: true });
    } catch (error) {
      setUnavailable(true);
    } finally {
      setLoading(false);
    }
  };

  if (unavailable) {
    return (
      <div className="auth">
        <img alt="logo" src={logo} />
        <h3 className="auth__deactivate--title">{UNAVAILABLE.TITLE}</h3>
        <p className="auth__deactivate--text">{UNAVAILABLE.TEXT}</p>
        <Link className="auth__deactivate--link" to={SCREENS.AUTH.SIGN_IN.path}>
          {UNAVAILABLE.LINK}
        </Link>
      </div>
    );
  }

  return <View onSubmit={onSubmit} loading={loading} />;
};

export default SetPassword;
